const layouts = {
  small: {
    rows: 3,
    columns: 4
  },

  medium: {
    rows: 3,
    columns: 6
  },

  large: {
    rows: 4,
    columns: 7
  }
}

export default layouts


// WEBPACK FOOTER //
// ./src/js/helpers/layouts.js